import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import Cookies from "js-cookie";

const cookie_lang = Cookies.get("lang");
const I18N_CACHE_BUST = process.env.REACT_APP_I18N_CACHE_BUST || "1";
i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: cookie_lang ? cookie_lang : "bn",
    supportedLngs: ["bn", "en"],
    load: "languageOnly",
    backend: {
      /* translation file path */
      // live url
      // loadPath: "/lic2/assets/i18n/{{ns}}/{{lng}}.json",
      loadPath: `/assets/i18n/{{ns}}/{{lng}}.json?v=${I18N_CACHE_BUST}`,

      // local url
      // loadPath: '/assets/i18n/{{ns}}/{{lng}}.json'
    },
    fallbackLng: cookie_lang ? cookie_lang : "bn",
    debug: true,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
